export const styles = {
  errorMessage: {
    whiteSpace: 'pre-line',
  },
};
